/**
 * Resolve the open game WebSocket. Prefer currentSocketRef (updated synchronously on
 * connect/handoff) over React ws state, which can lag during handoff navigation.
 */
export function getActiveGameWebSocketFrom(ws, socketRef) {
  const fromRef = socketRef?.current;
  if (fromRef && fromRef.readyState === WebSocket.OPEN) {
    return fromRef;
  }
  if (ws && ws.readyState === WebSocket.OPEN) {
    return ws;
  }
  return null;
}
